
export default {
  queryString (pagination) {
    return Object.keys(pagination).map(function (key) {
      return key + '=' + pagination[key]
    }).join('&')
  },

  createQueryParam(keyName, value) {
      if (value === '') return {}
      if (value !== null && value !== undefined) {
          return { [ keyName ]: value };
      }
      return {};
  },

  generatePaginationQuery(name = "", items = []) {
      const itemQueries = items?.map((item, index) => {
          const prefix = index === 0 ? '&' : ''
          return `${prefix}${name}=${item}`
      })
      return itemQueries?.join('&')
  }
}

/**
 * Returns black or white text for readable contrast on a hex background (WCAG luminance).
 */
export function getContrastingTextColor(hexColor) {
  if (!hexColor || typeof hexColor !== "string") return "#000000";

  const hex = hexColor.replace("#", "").trim();
  const normalized =
    hex.length === 3
      ? hex
          .split("")
          .map((char) => char + char)
          .join("")
      : hex;

  if (normalized.length !== 6 || Number.isNaN(Number.parseInt(normalized, 16))) {
    return "#000000";
  }

  const r = Number.parseInt(normalized.slice(0, 2), 16) / 255;
  const g = Number.parseInt(normalized.slice(2, 4), 16) / 255;
  const b = Number.parseInt(normalized.slice(4, 6), 16) / 255;

  const toLinear = (channel) =>
    channel <= 0.03928 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;

  const luminance =
    0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);

  // Threshold ~0.179 ≈ WCAG contrast preference between black/white
  return luminance > 0.179 ? "#000000" : "#FFFFFF";
}

